import { render, staticRenderFns } from "./TopProgress.vue?vue&type=template&id=0528f83d"
import script from "./TopProgress.vue?vue&type=script&lang=js"
export * from "./TopProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports